import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SidebarWOdetails from "./sidebarWOdetails";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import toast from "react-hot-toast";
import moment from "moment";
import { logRoles } from "@testing-library/react";
import Icon from "../../../components/icons";
import PartlistWOdetails from "./partslistWOdetails";

interface TimeLog {
  status: string;
  statusChangeDate: string;
  changedBy: string;
  timeSpent: string;
  note: string;
}
interface Props {
  workorder?: any;
  onUpdateRequest?: () => void;
}
const CompletionrecordWOdetails: React.FC<Props> = ({ workorder, onUpdateRequest = () => {} }) => {
  const params: any = useParams();

  const workOrderAPI: any = useWorkOrderApi();  
  
  const [showloader, setShowloader] = useState<boolean>(true); 
  const [wocompletedata, setWocompletedata] = useState<any>(null); 
  const [wocompleteattachment, setWocompleteattachment] = useState<any>([]); 
  const [wocompletionlogs, setWocompletionlogs] = useState<any>([]);

  // Function to convert UTC datetime in notes to local time
  const convertNotesDateTime = (notes: string): string => {
    if (!notes || notes === 'undefined') return notes;
    
    // Regex to match ISO 8601 datetime format (e.g., 2026-01-19T14:59:25.176Z)
    const isoDateRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z/g;
    
    return notes.replace(isoDateRegex, (match) => {
      return moment.utc(match).local().format('MM/DD/YYYY hh:mm:ss A');
    });
  };

  const timeLogs: TimeLog[] = [
    {
      status: "Scheduled",
      statusChangeDate: "10/15/24",
      changedBy: "John Doe",
      timeSpent: "00:06:02",
      note: "--",
    },
    {
      status: "Progress",
      statusChangeDate: "12/20/24",
      changedBy: "Will Smith",
      timeSpent: "00:04:02",
      note: "Starting the job earlier due to emergency",
    },
  ];

  const init_completion_record_details = async() => {
    const PromiseArr = [];

    // Get completion by id api promise construction
    PromiseArr.push(
      new Promise((resolve, reject) => {
          workOrderAPI.GetWorkOrderCompletionByID({WorkOrderID: workorder.workOrderID}, (resp: any) => {
            resolve(resp);
        }, (error: any) => { 
          toast.error(error);
          reject(error);
        })
      })
    );

    // Get completion attachments by id api promise construction
    PromiseArr.push(
      new Promise((resolve, reject) => {
          workOrderAPI.GetWorkOrderCompletionAttachments({WorkOrderID: workorder.workOrderID}, (resp: any) => {
            resolve(resp);
        }, (error: any) => { 
          toast.error(error);
          reject(error);
        })
      })
    );

    //Completion record details api call
    PromiseArr.push(
      new Promise((resolve, reject) => {
          workOrderAPI.GetWorkOrderCompletionLog({WorkOrderID: workorder.workOrderID}, (resp: any) => {
            resolve(resp);
        }, (error: any) => { 
          toast.error(error);
          reject(error);
        })
      })
    );



    const apiresp:any = await Promise.all(PromiseArr).catch((err:any) => {});
    if (apiresp && Array.isArray(apiresp) && apiresp.length > 0) {
        console.log(apiresp);

        // Handle the completion record details
        if (apiresp[0]) {
          setWocompletedata(apiresp[0]);
        }

        // Handle the completion attachments
        if (apiresp[1] && apiresp[1].hasOwnProperty("files") && Array.isArray(apiresp[1].files) && apiresp[1].files.length > 0) {
          console.log("completion attachments:", apiresp[1]);
          setWocompleteattachment(apiresp[1].files);
        }

        // Handle the completion logs
        if (apiresp[2] && apiresp[2].hasOwnProperty("workOrderList") && Array.isArray(apiresp[2].workOrderList) && apiresp[2].workOrderList.length > 0) {
          setWocompletionlogs(apiresp[2].workOrderList);
          //console.log("completion attachments:", apiresp[1]);
          //setWocompleteattachment(apiresp[1].files);
        }
    }

  };

  useEffect(() => {
    if (workorder) {
      init_completion_record_details();
    }
  }, []);

  return (
    <div className="flex">
      <div className="flex-grow border-r border-gray-200 pt-4">
        <div className="grid grid-cols-1 gap-6">          

          <div className="flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]">
            <div className="w-[14rem] text-[#767676]">
              <div className="mr-2">Initial Description:</div>
            </div>
            <div className="w-3/4 text-[#000000]">
              {workorder?.description || `--`}
              {(wocompleteattachment && wocompleteattachment.length > 0) && (
                <div className={`flex gap-3 flex-wrap mt-3`}>
                  {wocompleteattachment.map((file: any) => {
                      var ext = file.originalFileName.split('.').pop();
                      if ([`png`, `jpg`, `jpeg`, `gif`].includes(ext.toLowerCase())) {
                        return (
                          <a key={file.workOrderFileID} style={{ width: `101px`, height: `85px`, borderRadius: `5px`, overflow: `hidden` }} href={file.fullFilePath} target="_blank" rel="noopener noreferrer">
                            <img src={file.fullFilePath} alt={file.originalFileName} style={{ width: `100%`, height: `100%`, objectFit: `cover`, objectPosition: `center` }} />
                          </a>
                        );
                      } else {
                        <a key={file.workOrderFileID} style={{ width: `101px`, height: `85px`, borderRadius: `5px`, overflow: `hidden` }} href={file.fullFilePath} target="_blank" rel="noopener noreferrer">
                          <div style={{ width: `100%`, height: `100%`, display: `flex`, alignItems: `center`, justifyContent: `center`, background: `#eee` }}><Icon name="file" className="text-dark" /></div>
                        </a>
                      }
                  })}
                </div>
              )}
            </div>
          </div>

          <div className="flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]">
            <div className="w-[14rem] text-[#767676]">
              <div className="mr-2">Root cause:</div>
            </div>
            <div className="w-3/4 text-[#000000]">
              { (wocompletedata?.rootCause!== `undefined`? wocompletedata?.rootCause: `--`) || `--` }
            </div>
          </div>

          <div className="flex py-4 border-b border-gray-200 items-center flex-row text-[0.938rem]">
            <div className="w-[14rem] text-[#767676]">
              <div className="mr-2">Solution (Completion Note):</div>
            </div>
            <div className="w-3/4 text-[#000000]">
              { (wocompletedata?.completionNote!== `undefined`? wocompletedata?.completionNote: `--`) || `--` }
            </div>
          </div>

          <div className={ `flex ${wocompletedata?.fullFilePath? `pt-0 pb-4`: `py-4`} border-b border-gray-200 items-center flex-row text-[0.938rem]` }>
            <div className="w-[14rem] text-[#767676]">
              <div className="mr-2">Signature:</div>
            </div>
            <div className="w-3/4 text-[#000000]">
              { wocompletedata?.fullFilePath? (
                <img src={ wocompletedata?.fullFilePath } alt="Signature" className="" style={{ width: `200px`, minHeight: 44.56 }} />
              ): `--` }              
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-6">
          <div className={`pr-4`} style={{ marginTop: `50px` }}>
            <h2 className="text-base font-semibold mb-3" style={{ fontSize: `15px` }}>
              Task Time Spent Details
            </h2>
            <div className="overflow-x-auto rounded-md shadow">
              <table className="w-full border-collapse text-sm">
                <thead>
                  <tr className="bg-[#f0f0f0] text-left">
                    <th className="p-3 font-semibold" style={{ color: `#262A2D`, fontSize: `13px` }}>
                      Status
                    </th>
                    <th className="p-3 font-semibold" style={{ color: `#262A2D`, fontSize: `13px` }}>
                      Status Change Date
                    </th>
                    <th className="p-3 font-semibold" style={{ color: `#262A2D`, fontSize: `13px` }}>
                      Changed by
                    </th>
                    <th className="p-3 font-semibold" style={{ color: `#262A2D`, fontSize: `13px` }}>
                      Time Spent
                    </th>
                    <th className="p-3 font-semibold" style={{ color: `#262A2D`, fontSize: `13px` }}>
                      Note
                    </th>
                  </tr>
                </thead>    
                
                <tbody>
                  {wocompletionlogs.length > 0 && wocompletionlogs.map((log:any, index:number) => (
                    <tr key={index} className="border-t">
                      <td className="p-3" style={{ color: `#42484B`, fontSize: `15px` }}>
                        {log.status}
                      </td>
                      <td className="p-3" style={{ color: `#42484B`, fontSize: `15px` }}>
                        {moment.utc(log.statusChangeDate).local().format(`MM/DD/YYYY hh:mm a`)}
                      </td>
                      <td className="p-3" style={{ color: `#42484B`, fontSize: `15px` }}>
                        {log.changedByName}
                      </td>
                      <td className="p-3" style={{ color: `#42484B`, fontSize: `15px` }}>
                        {(() => {
                          const totalmint = +log.timeSpentMinutes || 0;
                          return (
                            `${Math.floor(totalmint / 60).toString()}h ${(totalmint % 60).toString()}m`
                          )
                        })()}                        
                      </td>                      
                      <td className="p-3 whitespace-pre-line w-2/5" style={{ color: `#42484B`, fontSize: `15px` }}>
                        {log.notes && log.notes!== `undefined`? <div className={ `line-clamp-2` } title={ convertNotesDateTime(log.notes) }>{convertNotesDateTime(log.notes)}</div>: `--`}
                      </td>                                         
                    </tr>
                  ))}
                </tbody>
                {wocompletionlogs.length === 0 && (
                  <tbody>
                    <tr>
                      <td colSpan={5}>
                        <div className="flex items-center justify-center text-[#42484B] text-sm" style={{ fontSize: `15px`, height: `100px` }}>
                          No time logs available.
                        </div>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </div>
        <div className="mb-6">
         <PartlistWOdetails workorder={workorder} onUpdate={onUpdateRequest} showUsedQty={true} />
         </div>
      </div>
      <div className="p-[1.125rem] overflow-y-auto flex-grow-0 flex-shrink-0" style={{ width: `312px` }}>
        {/* w-[19.5rem] */}
        <SidebarWOdetails workorder={workorder} />
      </div>
    </div>
  );
};

export default CompletionrecordWOdetails;
